import type { ActionCreator } from 'redux';

import type {
  GetBasicDetailQueryParams,
  MarketBasicDetail,
} from './interfaces/BasicDetail.model';
import type { Market } from './interfaces/Market';

export const GET_BASIC_DETAIL = 'product/GET_BASIC_DETAIL';
export const GET_BASIC_DETAIL_SUCCESS = 'product/GET_BASIC_DETAIL_SUCCESS';
export const SET_BASIC_DETAIL = 'product/SET_BASIC_DETAIL';

export interface GetBasicDetail {
  type: typeof GET_BASIC_DETAIL;
  queryParams: GetBasicDetailQueryParams;
}

export interface GetBasicDetailSuccess<M extends Market = 'b2c' | 'b2b'> {
  type: typeof GET_BASIC_DETAIL_SUCCESS;
  basicDetail: MarketBasicDetail<M>;
}
export interface SetBasicDetail<M extends Market = 'b2c' | 'b2b'> {
  type: typeof SET_BASIC_DETAIL;
  basicDetail: MarketBasicDetail<M>;
}

export const setBasicDetail: ActionCreator<SetBasicDetail> = <
  M extends Market = 'b2c' | 'b2b',
>(
  basicDetail: MarketBasicDetail<M>,
) => ({
  type: SET_BASIC_DETAIL,
  basicDetail,
});

export type Action = GetBasicDetail | GetBasicDetailSuccess | SetBasicDetail;
